import Adicionar from './Adicionar';
import Default from './Default';
import Editar from './Editar';

const EpisDefault = Default

export default EpisDefault;
export const EpisAdicionar = Adicionar;
export const EpisEditar = Editar;
